import React from 'react';
import PropTypes from 'prop-types';

import FormField from '../../../../components/FormField/index';
import {formToJSON} from '../../../../utils/misc';

class RecoverPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();
        let data = formToJSON(this.form);

        if (!data.email || data.email === '') {
            return false;
        }

        this.props.action(data.email);
    }

    render() {
        let buttonClass = this.props.loading ? 'is-loading' : '';

        return (
            <form className="form" onSubmit={this.onSubmit} ref={form => {
                this.form = form;
            }}>
                <FormField helper={(<p className="help is-danger">{this.props.warning}</p>)} label={this.props.placeholders.email}>
                    <input type="email" name="email" className="input"/>
                </FormField>

                <FormField>
                    <div className="submit-form" style={{margin: '40px auto 20px', width: '156px'}}>
                        <button type="submit" className={`button is-info ${buttonClass}`}>
                            {this.props.placeholders.submit}
                        </button>
                    </div>
                </FormField>
            </form>
        );
    }
}

RecoverPasswordForm.propTypes = {
    action: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    warning: PropTypes.string,
    placeholders: PropTypes.shape({
        email: PropTypes.string,
        submit: PropTypes.string
    })
};


RecoverPasswordForm.defaultProps = {
    warning: '',
    placeholders: {
        email: 'Email',
        submit: 'Submit'
    }
};

export default RecoverPasswordForm;
